import { Box, Chip, Typography } from '@mui/material';
import type { MouseEvent } from 'react';
import { alpha } from '@mui/material/styles';
import { Colors } from 'src/shared/components/styles';

type StatsBadgeProps = {
  label: string;
  value: number | string;
  size?: 'sm' | 'md';
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
};

export const StatsBadge = ({
  label,
  value,
  size = 'sm',
  onClick,
}: StatsBadgeProps) => {
  const isSmall = size === 'sm';
  return (
    <Chip
      size={isSmall ? 'small' : 'medium'}
      label={
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
          <Typography
            variant='caption'
            sx={{ fontSize: 11, color: Colors.BADGE_BLUE }} // theme.primary?
          >
            {label}
          </Typography>
          <Typography
            variant='caption'
            sx={{ fontWeight: 700, fontSize: 11, color: Colors.BADGE_BLUE }} // theme.primary?
          >
            {value}
          </Typography>
        </Box>
      }
      sx={{
        bgcolor: alpha(Colors.BADGE_BLUE, 0.15), // theme.primary?
        border: '1px solid',
        borderColor: Colors.BADGE_BLUE, // theme.primary?
        cursor: onClick ? 'pointer' : 'default',
        '& .MuiChip-label': {
          px: 0.75,
          py: 0,
        },
      }}
      onClick={onClick}
    />
  );
};

StatsBadge.defaultProps = {
  size: 'md',
  onClick: undefined,
};
